<template>
  <div class="kp-modular-section">
    <label class="kp-modular-label">{{$t('edit.sidebar.select_one_answer')}}</label>
    <select class="klickart-select" @change="jumpUpdateOptionId({ jump, index: 0, event: $event })">
      <option value="" disabled selected>{{$t('edit.sidebar.choose_one_answer')}}</option>
      <option
        v-for="(option, index) in optionList"
        :value="option.id"
        :selected="option.id === jump.options_ids[0]"
      >{{ option.label }}</option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: [
    'jump',
  ],
  computed: mapGetters({
    optionList: 'optionList',
  }),
  methods: mapActions([
    'jumpUpdateOptionId',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** SingleAnswer.vue?9847eba0
 **/